(() => {
  const page = document.querySelector('[data-softly-cart-page]');
  if (!page) return;

  let busy = false;
  const updateLine = async (row, quantity) => {
    if (busy) return;
    busy = true;
    const status = row.querySelector('[data-softly-cart-status]');
    const controls = row.querySelectorAll('button, input');
    controls.forEach((control) => { control.disabled = true; });
    if (status) status.textContent = 'Updating…';
    try {
      const response = await fetch(`${window.routes?.cart_change_url || '/cart/change.js'}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(row.dataset.softlyCartLine), quantity: Math.max(0, quantity) })
      });
      if (!response.ok) throw new Error('Unable to update cart');
      window.location.reload();
    } catch (error) {
      if (status) status.textContent = 'Unable to update. Please try again.';
      controls.forEach((control) => { control.disabled = false; });
      busy = false;
    }
  };

  page.addEventListener('click', (event) => {
    const row = event.target.closest('[data-softly-cart-line]');
    if (!row) return;
    const input = row.querySelector('[data-softly-cart-quantity]');
    if (event.target.closest('[data-softly-cart-decrease]')) updateLine(row, Number(input.value) - 1);
    if (event.target.closest('[data-softly-cart-increase]')) updateLine(row, Number(input.value) + 1);
    if (event.target.closest('[data-softly-cart-remove]')) updateLine(row, 0);
  });

  page.addEventListener('change', (event) => {
    if (!event.target.matches('[data-softly-cart-quantity]')) return;
    updateLine(event.target.closest('[data-softly-cart-line]'), Number(event.target.value));
  });
})();
